import { HttpClient, HttpResponse } from "@angular/common/http";
import { Component } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from "@angular/forms";
import { CookieService } from "ngx-cookie-service";
import { isUndefined } from "util";
import { BreadcrumbService } from "../../../../breadcrumb.service";
import { RouterConst } from "../../../../globals/RoutersConst";
import { ClientsService } from "../../../../services/clients/clients.service";
import { DashboardDataService } from "../../../../services/dashboard-data.service";
import { HttpService } from "../../../../services/http.service";
import { WsService } from "../../../../services/websocket/WsService";
import { SuperClass } from "../../../../superclass/SuperClass";
import { DynamicImageRule } from "./dynamic-image-rule.model";

declare let $: any;

@Component({
  selector: "app-dynamic-images",
  templateUrl: "./dynamic-images.component.html",
  styleUrls: ["./dynamic-images.component.css"]
})
export class DynamicImagesComponent extends SuperClass {
  display = false;
  templateNames;
  selectedTemplate;

  templateInfo;

  selectedRule: DynamicImageRule;
  newRule: DynamicImageRule;

  newRuleForm: FormGroup;
  selectedRuleForm: FormGroup;

  loginLogoImg;
  loginSplashImg;
  emailLoginLogoImg;
  emailLoginSplashImg;
  emailLoginNoPasswordLogoImg;
  emailLoginNoPasswordSplashImg;
  emailPasswordChangeLogoImg;
  emailPasswordChangeSplashImg;
  emailRegistrationLogoImg;
  emailRegistrationSplashImg;
  loyaltyCardLoginLogoImg;
  loyaltyCardLoginSplashImg;
  paypalLoginLogoImg;
  paypalLoginSplashImg;
  smsLoginLogoImg;
  smsLoginSplashImg;
  socialMediaLoginLogoImg;
  socialMediaLoginSplashImg;
  successLogoImg;
  successSplashImg;
  termsConditionsLoginLogoImg;
  termsConditionsLoginSplashImg;
  voucherLogoImg;
  voucherSplashImg;
  voucherLoginLogoImg;
  voucherLoginSplashImg;
  voucherRegistrationLogoImg;
  voucherRegistrationSplashImg;
  adsLoginLogoImg;
  adsLoginSplashImg;
  adImgId1;
  adImgId2;
  adImgId3;
  adImgId4;
  adImgId5;
  adImgId6;

  uploadViewId;
  uploadTag;
  uploadVariable;

  deviceTypes;
  periodsOfDay;
  periodsOfDayStart;
  periodsOfDayEnd;
  daysOfWeek;

  displayRule = false;
  private PERIOD_START_ANY = -1;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private uploadFileService: HttpService,
    private fb: FormBuilder
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService
    );

    this.breadcrumbService.setItems([
      { label: "Organization" },
      { label: "Captive Portal" },
      {
        label: "Dynamic Images",
        routerLink: [{ outlets: { sub: [RouterConst.DYNAMIC_IMAGES] } }]
      }
    ]);
    this.newRule = new DynamicImageRule();
  }

  reloadData() {
    this.http_getTemplateNames((data: any) => {
      this.templateNames = data.payload;
    });

    this.http_getStrategyPeriodOfDay((data: any) => {
      this.periodsOfDay = data.payload;
      this.periodsOfDayEnd = data.payload;
      this.periodsOfDayStart = data.payload.filter(function(el) {
        return el.id !== 24;
      });
    });

    this.http_getStrategyDayOfWeek((data: any) => {
      this.daysOfWeek = data.payload;
    });

    this.http_getStrategyDeviceType((data: any) => {
      this.deviceTypes = data.payload;
    });

    this.selectedRuleForm = this.fb.group({
      dayOfWeek: new FormControl("", Validators.required),
      periodStart: new FormControl("", Validators.required),
      periodEnd: new FormControl("", Validators.required),
      deviceType: new FormControl("", Validators.required)
    });

    this.newRuleForm = this.fb.group({
      dayOfWeek: new FormControl("", Validators.required),
      periodStart: new FormControl("", Validators.required),
      periodEnd: new FormControl("", Validators.required),
      deviceType: new FormControl("", Validators.required)
    });
  }

  selectTemplate(e) {
    this.http_getDynamicImages(e.value.id, (data: any) => {
      this.templateInfo = data.payload;
    });
  }

  selectRow(e) {
    this.selectedRule = new DynamicImageRule(e.data);
    this.loginLogoImg = this.loginSplashImg = this.emailLoginLogoImg = this.emailLoginSplashImg = this.emailLoginNoPasswordLogoImg = this.emailLoginNoPasswordSplashImg = this.emailPasswordChangeLogoImg = this.emailPasswordChangeSplashImg = this.emailRegistrationLogoImg = this.emailRegistrationSplashImg = this.loyaltyCardLoginLogoImg = this.loyaltyCardLoginSplashImg = this.paypalLoginLogoImg = this.paypalLoginSplashImg = this.smsLoginLogoImg = this.smsLoginSplashImg = this.socialMediaLoginLogoImg = this.socialMediaLoginSplashImg = this.successLogoImg = this.successSplashImg = this.termsConditionsLoginLogoImg = this.termsConditionsLoginSplashImg = this.voucherLogoImg = this.voucherSplashImg = this.voucherLoginLogoImg = this.voucherLoginSplashImg = this.voucherRegistrationLogoImg = this.voucherRegistrationSplashImg = this.adsLoginLogoImg = this.adsLoginSplashImg = this.adImgId1 = this.adImgId2 = this.adImgId3 = this.adImgId4 = this.adImgId5 = this.adImgId6 = undefined;

    this.getImage(e.data.id, "login", "logo", "loginLogoImg");
    this.getImage(e.data.id, "login", "splashImage", "loginSplashImg");

    this.getImage(e.data.id, "email_login", "logo", "emailLoginLogoImg");
    this.getImage(
      e.data.id,
      "email_login",
      "splashImage",
      "emailLoginSplashImg"
    );

    this.getImage(
      e.data.id,
      "email_login_no_password",
      "logo",
      "emailLoginNoPasswordLogoImg"
    );
    this.getImage(
      e.data.id,
      "email_login_no_password",
      "splashImage",
      "emailLoginNoPasswordSplashImg"
    );

    this.getImage(
      e.data.id,
      "email_password_change",
      "logo",
      "emailPasswordChangeLogoImg"
    );
    this.getImage(
      e.data.id,
      "email_password_change",
      "splashImage",
      "emailPasswordChangeSplashImg"
    );

    this.getImage(
      e.data.id,
      "email_registration",
      "logo",
      "emailRegistrationLogoImg"
    );
    this.getImage(
      e.data.id,
      "email_registration",
      "splashImage",
      "emailRegistrationSplashImg"
    );

    this.getImage(
      e.data.id,
      "loyalty_card_login",
      "logo",
      "loyaltyCardLoginLogoImg"
    );
    this.getImage(
      e.data.id,
      "loyalty_card_login",
      "splashImage",
      "loyaltyCardLoginSplashImg"
    );

    this.getImage(e.data.id, "paypal_login", "logo", "paypalLoginLogoImg");
    this.getImage(
      e.data.id,
      "paypal_login",
      "splashImage",
      "paypalLoginSplashImg"
    );

    this.getImage(e.data.id, "sms_login", "logo", "smsLoginLogoImg");
    this.getImage(e.data.id, "sms_login", "splashImage", "smsLoginSplashImg");

    this.getImage(
      e.data.id,
      "social_media_login",
      "logo",
      "socialMediaLoginLogoImg"
    );
    this.getImage(
      e.data.id,
      "social_media_login",
      "splashImage",
      "socialMediaLoginSplashImg"
    );

    this.getImage(e.data.id, "success", "logo", "successLogoImg");
    this.getImage(e.data.id, "success", "splashImage", "successSplashImg");

    this.getImage(
      e.data.id,
      "terms_conditions_login",
      "logo",
      "termsConditionsLoginLogoImg"
    );
    this.getImage(
      e.data.id,
      "terms_conditions_login",
      "splashImage",
      "termsConditionsLoginSplashImg"
    );

    this.getImage(e.data.id, "voucher", "logo", "voucherLogoImg");
    this.getImage(e.data.id, "voucher", "splashImage", "voucherSplashImg");

    this.getImage(e.data.id, "voucher_login", "logo", "voucherLoginLogoImg");
    this.getImage(
      e.data.id,
      "voucher_login",
      "splashImage",
      "voucherLoginSplashImg"
    );

    this.getImage(
      e.data.id,
      "voucher_registration",
      "logo",
      "voucherRegistrationLogoImg"
    );
    this.getImage(
      e.data.id,
      "voucher_registration",
      "splashImage",
      "voucherRegistrationSplashImg"
    );

    this.getImage(e.data.id, "ads_page", "logo", "adsLoginLogoImg");
    this.getImage(e.data.id, "ads_page", "splashImage", "adsLoginSplashImg");
    this.getImage(e.data.id, "ads_page", "adImgId1", "adImgId1");
    this.getImage(e.data.id, "ads_page", "adImgId2", "adImgId2");
    this.getImage(e.data.id, "ads_page", "adImgId3", "adImgId3");
    this.getImage(e.data.id, "ads_page", "adImgId4", "adImgId4");
    this.getImage(e.data.id, "ads_page", "adImgId5", "adImgId5");
    this.getImage(e.data.id, "ads_page", "adImgId6", "adImgId6");
  }

  getImage(ruleId, viewId, tag, variable) {
    this.http_getImageInfo(ruleId, viewId, tag, (data: any) => {
      this[variable] = data.payload;
    });
  }

  removeImage(img) {
    img.image = [];
    this.http_removeImage(img, (data: any) => {});
  }

  saveChanges() {
    this.http_dynamicImageUpdateRule(this.selectedRule, (data: any) => {
      this.loadRulesFromResponse(data);
      this.showSuccessMessage("Rule has been updated");
    });
  }

  removeRule() {
    this.http_dynamicImageDeleteRule(
      { id: this.selectedRule.id },
      (data: any) => {
        this.loadRulesFromResponse(data);
        this.showSuccessMessage("Rule has been deleted");
      }
    );
  }

  addRule() {
    this.displayRule = true;
  }

  createNewRule() {
    this.newRule.templateId = this.selectedTemplate.id;

    const conflictingRule = this.findConfiltingRule(this.newRule);
    if (!isUndefined(conflictingRule)) {
      this.showMessage(
        "error",
        "Conflicting Rule exists",
        "Rule with same day of week, device type, number of login " +
          "and period from " +
          conflictingRule.periodStart.description +
          " to " +
          conflictingRule.periodEnd.description
      );
      return;
    }

    this.http_dynamicImageAddRule(this.newRule, (data: any) => {
      this.loadRulesFromResponse(data);
      this.showSuccessMessage("New rule has been created");
      this.newRuleForm.reset();
    });
    this.displayRule = false;
  }

  uploadImage(viewId, tag, variable) {
    this.uploadVariable = variable;
    this.uploadViewId = viewId;
    this.uploadTag = tag;
    document.getElementById("fileUpload").click();
  }

  upload(file) {
    this.uploadFileService
      .uploadDynamicImage(
        this.selectedRule.id,
        this.uploadViewId,
        this.uploadTag,
        file
      )
      .subscribe((event: any) => {
        if (event instanceof HttpResponse) {
          this.getImage(
            this.selectedRule.id,
            this.uploadViewId,
            this.uploadTag,
            this.uploadVariable
          );
        }
      });
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }

  periodStartChanged(e) {
    const periodStartId = isUndefined(e)
      ? this.selectedRule.periodStart.id
      : e.id;
    if (periodStartId === this.PERIOD_START_ANY) {
      this.selectedRule.periodEnd = this.periodsOfDay.filter(function(el) {
        return el.id === periodStartId;
      })[0];
      this.periodsOfDayEnd = [this.selectedRule.periodEnd];
    } else {
      this.periodsOfDayEnd = this.periodsOfDay.filter(function(el) {
        return el.id > periodStartId;
      });
    }
  }

  periodStartNewChanged() {
    const periodStartId = this.newRule.periodStart.id;
    if (periodStartId === this.PERIOD_START_ANY) {
      this.newRule.periodEnd = this.periodsOfDay.filter(function(el) {
        return el.id === periodStartId;
      })[0];
      this.periodsOfDayEnd = [this.newRule.periodEnd];
    } else {
      this.periodsOfDayEnd = this.periodsOfDay.filter(function(el) {
        return el.id > periodStartId;
      });
    }
  }

  findConfiltingRule(rule: DynamicImageRule) {
    let conflictingRule: DynamicImageRule;
    this.templateInfo.forEach(function(el) {
      if (
        el.dayOfWeek.id === rule.dayOfWeek.id &&
        el.deviceType.id === rule.deviceType.id
      ) {
        if (
          (rule.periodStart.id <= el.periodStart.id &&
            rule.periodEnd.id > el.periodStart.id) ||
          (rule.periodStart.id < el.periodEnd.id &&
            rule.periodEnd.id >= el.periodEnd.id) ||
          (rule.periodStart.id >= el.periodStart.id &&
            rule.periodEnd.id <= el.periodEnd.id)
        ) {
          if (el.id !== rule.id) {
            conflictingRule = el;
            return;
          }
        }
      }
    });
    return conflictingRule;
  }

  unselectRow() {
    this.selectedRule = undefined;
  }

  private loadRulesFromResponse(data) {
    this.templateInfo = data.payload;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/captive-portal/dynamic-images/dynamic-images.component.ts